import React from 'react';
import { BgImage } from './../../../components';
import { heights, widths, fonts } from './../../../styles/theme.json';
import ScrollPrompt from '../../../components/ScrollPrompt';
import { breakpoints } from '../../../styles/theme.json';
import { returnOpacity } from './../../../scripts';
import { connect } from 'react-redux';



const ArticleHero = (props) => {
  const gradientStyle = {
    opacity: returnOpacity(props.heroData.gradient_opacity)
  };

  return (
    <section id={'article-hero'}>
      {(props.heroData.headline_options !== 'no_headline') &&
        <div className={'article-title-wrapper ' + props.heroData.hero_fonts + ' ' + props.heroData.hero_text_size + ' ' + props.heroData.headline_options + ' '+ props.heroData.headline_align}>
          <div className={(props.heroData.drop_shadow) ? 'article-title text-shadow' : 'article-title'}>
            <h1 className={'blog-header'}>{props.heroData.headline}</h1>
            {(props.heroData.hero_image_caption) &&
              <p className={'hero-caption'}>{props.heroData.hero_image_caption}</p>
            }
          </div>
        </div>
      }
      <div className={'hero-image'}>
        <BgImage source={props.heroData.hero_image.large}/>
        <div className="slide-gradient" style={gradientStyle}/>
      </div>
      {(props.window_width >= breakpoints.desktop) && <ScrollPrompt />}
    </section>
  );
};

// export default ArticleHero;
export default connect(
  state => ({
    window_width: state.window_dimensions.window_width
  })
)(ArticleHero);


// WEBPACK FOOTER //
// ./src/pages/blog/blog_single/article_hero.js